
import React from 'react';
import { useDispatch } from 'react-redux';
import { IoMdTime } from 'react-icons/io';
import { FaRegCheckCircle } from 'react-icons/fa';
// import TabComponent from '../TabComponent';

import TabComponent from '../../../../Components/TabComponent/TabComponent';
import PurchaseApprovalApproved from './SchemeApprovalApproved';
import PurchaseApprovalPending from './SchemeApprovalPending';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { IoMdCloseCircleOutline } from "react-icons/io";
import SchemeApprovalPending from './SchemeApprovalPending';
import SchemeApprovalApproved from './SchemeApprovalApproved';
import SchemeApprovalReject from './SchemeApprovalReject';
import SchemeApprovalReApproval from './SchemeApprovalReApproval';

// import { IoMdTime } from "react-icons/io";

const SchemeApprovalTabs = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setHeaderName("Scheme Approval"));
        dispatch(setSubHeaderName("Gold stake"));

    }, [dispatch]);

    const tabsHeadData = [
        { label: 'Pending', icon: <IoMdTime /> },
        { label: 'Approved', icon: <FaRegCheckCircle /> },
        { label: 'Reject', icon: <IoMdCloseCircleOutline /> },
        { label: 'Re Approval', icon: <IoMdTime /> },
        
    ];

    const tabsComponent = [
        <SchemeApprovalPending />,
        <SchemeApprovalApproved />,   
        <SchemeApprovalReject />,
        <SchemeApprovalReApproval/>
        
    ];

    return (
        <div>
            <TabComponent tabsData={tabsHeadData} tabComponents={tabsComponent} />
        </div>
    );
};

export default SchemeApprovalTabs;
